import { render, staticRenderFns } from "./ProjectSettlement.vue?vue&type=template&id=0ac3676e&scoped=true"
import script from "./ProjectSettlement.vue?vue&type=script&lang=js"
export * from "./ProjectSettlement.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettlement.vue?vue&type=style&index=0&id=0ac3676e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac3676e",
  null
  
)

export default component.exports